<mat-accordion *ngIf="formField && item" class="custom-accordion w-p-100">
  <mat-expansion-panel [expanded]='isExpanded' (opened)="changeExpand(true)"
                       (closed)="changeExpand(false)">
    <mat-expansion-panel-header>
      <mat-panel-title class="flex flex-row justify-between items-center">
        <div style="width:100%">
          <div class="flex flex-row justify-start items-center" *ngIf='formField.header || formField.headerDetails'>
            <div class="full-grow-no-shrink-no-basis">
              {{formField.header}}
            </div>

            <div class="buttons-container flex flex-row justify-start items-center">
              <button *ngIf="showViewDetails" mat-button class="link-button m-l-20" (click)="openGridView()">
                View as Grid
              </button>
              <div class="divider" *ngIf="showViewDetails && formField.headerDetails"></div>
              <button *ngIf="formField.headerDetails" mat-button class="link-button"
                      (click)="openHeaderDetails(formField.header, formField.headerDetails)">
                View Details
              </button>
              <div class="divider" *ngIf="(showViewDetails||formField.headerDetails) && showDelete"></div>
              <a *ngIf="showDelete" class="link-color delete-section" (click)="onDeleteItemClick()"
                 particleAnalytics analyticsCategory="link-cell-viewer" [analyticsAction]="'DeleteSection'">
                Delete Section
              </a>
              <div class="divider"
                   *ngIf="(showViewDetails||formField.headerDetails || showDelete) && (formFieldsErrorInformation && formFieldsErrorInformation[formField.headerKey+'__'+item.id])"></div>
              <!--<span *ngIf="formFieldsErrorInformation && formFieldsErrorInformation[formField.headerKey+'__'+item.id]" >
                  {{formFieldsErrorInformation[formField.headerKey+'__'+item.id].totalEmptyFields}}/<span style="color: red;">{{formFieldsErrorInformation[formField.headerKey+'__'+item.id].totalEmptyMandatoryFields}}</span>
              </span>-->
              <particle-dynamic-tooltip-container
                *ngIf="hasFormFieldsErrorInformation()"
                [component]="'FilingMandatoryFieldErrorTooltipComponent'"
                [metadata]="errorFieldCount">
                <div class="mandatory-field-hints-container flex flex-row justify-start items-center">
                  <div
                    class="error-count">{{formFieldsErrorInformation[formField.headerKey + '__' + item.id].totalEmptyMandatoryFields}}</div>
                </div>
              </particle-dynamic-tooltip-container>

              <!--              <particle-dynamic-tooltip-container-->
              <!--                [component]="'FilingMandatoryFieldErrorTooltipComponent'"-->
              <!--                [metadata]="errorFieldCount">-->
              <!--                <div class="mandatory-field-hints-container" fxLayout="row" fxLayoutAlign="start center" *ngIf="formFieldsErrorInformation && formFieldsErrorInformation[formField.headerKey+'__'+item.id]" >-->
              <!--                  <div class="total-count">-->
              <!--                    {{formFieldsErrorInformation[formField.headerKey+'__'+item.id].totalEmptyFields}}-->
              <!--                  </div>-->
              <!--                  <div class="seprator">-->
              <!--                    /-->
              <!--                  </div>-->
              <!--                  <div class="error-count" >{{formFieldsErrorInformation[formField.headerKey+'__'+item.id].totalEmptyMandatoryFields}}</div>-->
              <!--                </div>-->
              <!--              </particle-dynamic-tooltip-container>-->
            </div>

          </div>
        </div>

        <div class="flex flex-row justify-start items-center">
          <button *ngIf="designMode" mat-icon-button class="icon-dropdown-button" (click)="$event.stopPropagation()"
                  [matMenuTriggerFor]="panelActions">
            <mat-icon class="s-20">more_vert</mat-icon>
          </button>
          <mat-menu #panelActions="matMenu">
            <button mat-menu-item (click)="doAction('Rename')">
              <span>Rename</span>
            </button>
            <button mat-menu-item (click)="doAction('AddSection')">
              <span>Add Section</span>
            </button>
            <button mat-menu-item (click)="doAction('NonCollapsible')">
              <span>Non Collapsible</span>
            </button>
            <button mat-menu-item (click)="doAction('AddField')">
              <span>Add Field</span>
            </button>
            <button mat-menu-item (click)="doAction('AddNote')">
              <span>Add Note</span>
            </button>
            <button mat-menu-item (click)="doAction('MoveUp')">
              <span>Move Up</span>
            </button>
            <button mat-menu-item (click)="doAction('MoveDown')">
              <span>Move Down</span>
            </button>
            <button mat-menu-item (click)="doAction('DeleteSection')">
              <span>Delete Section</span>
            </button>

          </mat-menu>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <particle-dynamic-form-field-definitions
      *ngIf="!formField.isHidden && isExpanded"
      [formField]="formField"
      [sourceType]="sourceType"
      [showDelete]="showDelete"
      [endpointName]="endpointName"
      [item]="item"
      [showOriginal]="showOriginal"
      [invalidateSubject]="invalidateSubject"
      [showLanguageOption]="showLanguageOption"
      [designMode]="designMode"
      [editedFields]="editedFields"
      (valueChanged)="onValueChanged($event)"
      [formFieldsErrorInformation]="formFieldsErrorInformation"
      [formFieldsValidationState]="formFieldsValidationState"
    >
    </particle-dynamic-form-field-definitions>


  </mat-expansion-panel>
</mat-accordion>
